import { Link } from 'react-router-dom';
import { useAlbums } from './useAlbums';
import { Spinner } from '@/components/Spinner';

export function AlbumsList() {
  const { data, isLoading } = useAlbums();
  if (isLoading)
    return (
      <div className="py-8 text-center text-hint">
        <Spinner />
      </div>
    );
  if (!data || data.length === 0)
    return <p className="text-hint text-sm py-6">Альбомов пока нет</p>;
  return (
    <ul className="grid grid-cols-2 gap-3">
      {data.map((a) => (
        <li key={a.id}>
          <Link
            to={`/albums/${a.id}`}
            className="group block rounded-2xl overflow-hidden aspect-square relative"
            style={{ border: '1px solid var(--line-1)' }}
          >
            <img
              src={a.coverUrl}
              alt={a.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
            />
            <span className="absolute inset-x-0 bottom-0 p-3 font-display font-bold text-[13px] tracking-tight bg-gradient-to-t from-black/90 via-black/40 to-transparent text-white">
              {a.title}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
